// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as RescriptReactRouter from "@rescript/react/src/RescriptReactRouter.bs.js";
import * as Types$OrcaPaymentPage from "./hyper-loader/Types.bs.js";
import * as Utils$OrcaPaymentPage from "./Utilities/Utils.bs.js";
import * as Payment$OrcaPaymentPage from "./Payment.bs.js";
import * as CardTheme$OrcaPaymentPage from "./CardTheme.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as Redsys3ds$OrcaPaymentPage from "./Redsys3ds.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "./Utilities/JotaiAtoms.bs.js";
import * as PazeWallet$OrcaPaymentPage from "./Payments/PazeWallet.bs.js";
import * as HyperLogger$OrcaPaymentPage from "./hyper-log-catcher/HyperLogger.bs.js";
import * as ThreeDSAuth$OrcaPaymentPage from "./ThreeDSAuth.bs.js";
import * as DefaultTheme$OrcaPaymentPage from "./DefaultTheme.bs.js";
import * as CardThemeType$OrcaPaymentPage from "./Types/CardThemeType.bs.js";
import * as PaymentLoader$OrcaPaymentPage from "./Components/PaymentLoader.bs.js";
import * as QRCodeDisplay$OrcaPaymentPage from "./Payments/QRCodeDisplay.bs.js";
import * as ThreeDSMethod$OrcaPaymentPage from "./ThreeDSMethod.bs.js";
import * as PlaidSDKIframe$OrcaPaymentPage from "./Payments/PlaidSDKIframe.bs.js";
import * as PreMountLoader$OrcaPaymentPage from "./Payments/PreMountLoader.bs.js";
import * as VoucherDisplay$OrcaPaymentPage from "./Payments/VoucherDisplay.bs.js";
import * as LoaderController$OrcaPaymentPage from "./LoaderController.bs.js";
import * as PaymentMethodsSDK$OrcaPaymentPage from "./Payments/PaymentMethodsSDK.bs.js";
import * as BankTransfersPopup$OrcaPaymentPage from "./Payments/BankTransfersPopup.bs.js";
import * as NetworkInformation$OrcaPaymentPage from "./Hooks/NetworkInformation.bs.js";
import * as ClickToPayLearnMore$OrcaPaymentPage from "./Components/ClickToPayLearnMore.bs.js";
import * as FullScreenDivDriver$OrcaPaymentPage from "./Components/FullScreenDivDriver.bs.js";
import * as ThreeDSRedirectionModal$OrcaPaymentPage from "./Payments/ThreeDSRedirectionModal.bs.js";
import * as PaymentMethodCollectElement$OrcaPaymentPage from "./PaymentMethodCollectElement.bs.js";

function App(props) {
  let url = RescriptReactRouter.useUrl(undefined, undefined);
  let match = React.useState(() => false);
  let setIntegrateErrorError = match[1];
  let integrateError = match[0];
  let setLoggerState = Jotai.useSetAtom(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let paymentMode = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "componentName");
  let paymentType = CardThemeType$OrcaPaymentPage.getPaymentMode(paymentMode);
  let networkStatus = NetworkInformation$OrcaPaymentPage.useNetworkInformation();
  let match$1 = React.useMemo(() => [
    HyperLogger$OrcaPaymentPage.make(undefined, {
      TAG: "Elements",
      _0: paymentType
    }, undefined, undefined, undefined),
    Date.now()
  ], []);
  let initTimestamp = match$1[1];
  let logger = match$1[0];
  React.useEffect(() => {
    if (typeof networkStatus === "object") {
      logger.setLogInfo(JSON.stringify(networkStatus._0), "NETWORK_STATE", undefined, undefined, "DEBUG", undefined, undefined);
    }
  }, [networkStatus]);
  let fullscreenMode = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "fullscreenType");
  React.useEffect(() => {
    setLoggerState(param => logger);
  }, [logger]);
  React.useEffect(() => {
    let handleMetaDataPostMessage = ev => {
      let json = Utils$OrcaPaymentPage.safeParse(ev.data);
      let dict = Utils$OrcaPaymentPage.getDictFromJson(json);
      if (Core__Option.isSome(dict["metadata"])) {
        let metadata = Utils$OrcaPaymentPage.getJsonObjectFromDict(dict, "metadata");
        let config = Utils$OrcaPaymentPage.getDictFromJson(metadata)["config"];
        if (config !== undefined) {
          let config$1 = CardTheme$OrcaPaymentPage.itemToObjMapper(Utils$OrcaPaymentPage.getDictFromJson(config), DefaultTheme$OrcaPaymentPage.default, DefaultTheme$OrcaPaymentPage.defaultRules, logger);
          CardUtils$OrcaPaymentPage.generateFontsLink(config$1.fonts);
          let dict$1 = Utils$OrcaPaymentPage.getDictFromJson(config$1.appearance.rules);
          if (Object.entries(dict$1).length > 0) {
            Utils$OrcaPaymentPage.generateStyleSheet("", dict$1, "mystyle");
          }
        }
      }
      let appearanceJson = Utils$OrcaPaymentPage.getDictIsSome(dict, "paymentElementCreate") ? Utils$OrcaPaymentPage.getDictFromObj(dict, "paymentOptions")["appearance"] : (
          Utils$OrcaPaymentPage.getDictIsSome(dict, "fullScreenIframeMounted") ? dict["appearance"] : (
              Utils$OrcaPaymentPage.getDictIsSome(dict, "ElementsUpdate") ? Utils$OrcaPaymentPage.getDictFromObj(dict, "options")["appearance"] : undefined
            )
        );
      if (appearanceJson !== undefined) {
        return CardTheme$OrcaPaymentPage.setColorSchemeMeta(CardTheme$OrcaPaymentPage.getColorScheme(Utils$OrcaPaymentPage.getString(Utils$OrcaPaymentPage.getDictFromJson(appearanceJson), "colorScheme", "light")));
      }
    };
    window.addEventListener("message", handleMetaDataPostMessage);
    return () => {
      window.removeEventListener("message", handleMetaDataPostMessage);
    };
  }, []);
  switch (paymentMode) {
    case "paymentMethodCollect" :
      return JsxRuntime.jsx(LoaderController$OrcaPaymentPage.make, {
        children: JsxRuntime.jsx(PaymentMethodCollectElement$OrcaPaymentPage.make, {
          integrateError: integrateError,
          logger: logger
        }),
        paymentMode: paymentMode,
        setIntegrateErrorError: setIntegrateErrorError,
        logger: logger,
        initTimestamp: initTimestamp
      });
    case "paymentMethodsSDK" :
      return JsxRuntime.jsx(LoaderController$OrcaPaymentPage.make, {
        children: JsxRuntime.jsx(PaymentMethodsSDK$OrcaPaymentPage.make, {}),
        paymentMode: paymentMode,
        setIntegrateErrorError: setIntegrateErrorError,
        logger: logger,
        initTimestamp: initTimestamp
      });
    default:
      switch (fullscreenMode) {
        case "3ds" :
          return JsxRuntime.jsx(ThreeDSMethod$OrcaPaymentPage.make, {});
        case "3dsAuth" :
          return JsxRuntime.jsx(ThreeDSAuth$OrcaPaymentPage.make, {});
        case "3dsRedirectionPopup" :
          return JsxRuntime.jsx(ThreeDSRedirectionModal$OrcaPaymentPage.make, {});
        case "clickToPayLearnMore" :
          return JsxRuntime.jsx(ClickToPayLearnMore$OrcaPaymentPage.make, {});
        case "fullscreen" :
          return JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx(FullScreenDivDriver$OrcaPaymentPage.make, {}),
            id: "fullscreen"
          });
        case "paymentloader" :
          return JsxRuntime.jsx(PaymentLoader$OrcaPaymentPage.make, {});
        case "pazeWallet" :
          return JsxRuntime.jsx(PazeWallet$OrcaPaymentPage.make, {
            logger: logger
          });
        case "plaidSDK" :
          return JsxRuntime.jsx(PlaidSDKIframe$OrcaPaymentPage.make, {});
        case "preMountLoader" :
          let sdkAuthorization = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "sdkAuthorization");
          let clientSecret = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "clientSecret");
          let sessionId = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "sessionId");
          let publishableKey = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "publishableKey");
          let endpoint = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "endpoint");
          let pmSessionId = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "pmSessionId");
          let hyperComponentName = Types$OrcaPaymentPage.getHyperComponentNameFromStr(CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "hyperComponentName"));
          let merchantHostname = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "merchantHostname");
          let customPodUri = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "customPodUri");
          let isTestMode = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "isTestMode") === "true";
          let isSdkParamsEnabled = CardUtils$OrcaPaymentPage.getQueryParamsDictforKey(url.search, "isSdkParamsEnabled") === "true";
          return JsxRuntime.jsx(PreMountLoader$OrcaPaymentPage.make, {
            sessionId: sessionId,
            publishableKey: publishableKey,
            sdkAuthorization: sdkAuthorization,
            clientSecret: clientSecret,
            endpoint: endpoint,
            pmSessionId: pmSessionId,
            hyperComponentName: hyperComponentName,
            merchantHostname: merchantHostname,
            customPodUri: customPodUri,
            isTestMode: isTestMode,
            isSdkParamsEnabled: isSdkParamsEnabled
          });
        case "qrData" :
          return JsxRuntime.jsx(QRCodeDisplay$OrcaPaymentPage.make, {});
        case "redsys3ds" :
          return JsxRuntime.jsx(Redsys3ds$OrcaPaymentPage.make, {});
        case "achBankTransfer" :
        case "bacsBankTransfer" :
        case "sepaBankTransfer" :
          return JsxRuntime.jsx(BankTransfersPopup$OrcaPaymentPage.make, {
            transferType: fullscreenMode
          });
        case "voucherData" :
          return JsxRuntime.jsx(VoucherDisplay$OrcaPaymentPage.make, {});
        default:
          return JsxRuntime.jsx(LoaderController$OrcaPaymentPage.make, {
            children: JsxRuntime.jsx(Payment$OrcaPaymentPage.make, {
              paymentMode: paymentMode,
              integrateError: integrateError,
              logger: logger
            }),
            paymentMode: paymentMode,
            setIntegrateErrorError: setIntegrateErrorError,
            logger: logger,
            initTimestamp: initTimestamp
          });
      }
  }
}

let make = App;

export {
  make,
}
/* jotai Not a pure module */
